import React, { lazy } from 'react';

const NfpaRedirect = lazy(() => import('./containers/NfpaRedirect'));

const routes = {
  settings: {
    helpCategories: ['nfpa'],
  },
  auth: ({ profile } = {}) => Boolean(profile),
  routes: [
    {
      path: '/nfpa',
      exact: true,
      component: NfpaRedirect,
    },
    {
      path: '/nfpa/admin',
      component: () => <NfpaRedirect redirectTo="program" />,
    },
    {
      path: ['/nfpa/survey/:id', '/nfpa/survey', '/nfpa/surveys'],
      component: NfpaRedirect,
    },
  ],
};

export default routes;
